import { z } from 'zod';
// ── Billing — Stripe Connect schemas (JQ4-35 · US-PAGOS-001) ─────────────────
//
// Zod schemas + TS types for the billing API.
// The access_token MUST NEVER appear in any of these schemas.
// ── StripeConnectionStatusResponse ───────────────────────────────────────────
//
// Returned by GET /billing/stripe/status.
// Two shapes: not-connected (connected: false) or connected (connected: true).
export const StripeConnectionStatusResponseSchema = z.discriminatedUnion('connected', [
    z.object({
        connected: z.literal(false),
    }),
    z.object({
        connected: z.literal(true),
        accountName: z.string().optional(),
        livemode: z.boolean(),
    }),
]);
// ── StartStripeConnectResponse ────────────────────────────────────────────────
//
// The GET /billing/stripe/connect endpoint returns JSON { url } with the
// Stripe authorize URL. This schema represents that response body.
// In practice startStripeConnect() triggers window.location.href navigation.
export const StartStripeConnectResponseSchema = z.object({
    authorizeUrl: z.string().url(),
});
// ── DisconnectStripeResponse ──────────────────────────────────────────────────
//
// Returned by POST /billing/stripe/disconnect.
export const DisconnectStripeResponseSchema = z.object({
    connected: z.literal(false),
});
//# sourceMappingURL=billing-schemas.js.map